// Mock data for Register Point CA Services clone

export const heroServices = [
  'Tax Filing',
  'GST Registration',
  'Trademark Registration',
  'Book keeping & Outsourcing',
  'Company Formation & Registration',
  'FDI Compliance',
  'Company Annual Filing',
  'FSSAI Registration',
];

export const topBarContacts = {
  phone1: null,
  phone2: null,
  email: 'info@registerpoint.com',
};

export const serviceCategories = [
  'CA Services',
  'Company Formation',
  'Company Secretarial',
  'Bookkeeping',
  'Auditing',
  'Statutory Reporting',
  'Business Startup Consultancy',
  'Business Consultancy',
  'Business Analysis',
  'DIR-3 KYC',
  'Tax Planning',
  'Company Closure',
  'Registered Address Change',
  'Business Recovery',
  'Business Valuations',
  'Due Diligence',
  'Family Business Consulting',
  'Financial Planning',
  'Financial Reporting',
  'Income Tax Consulting',
  'Change in Share Capital',
  'Director Appointments',
  'E-commerce Startup Consulting',
  'Wealth Management',
  'Shop License',
  'GST Consulting',
  'TDS Consulting',
  'Payroll Consulting',
  'Investment Advisory',
  'Tax Filing Expert',
  'Foreign Taxation',
  'Income Tax Return',
  'Risk Management Advisory',
  'APEDA Registration',
  'Trademark Registration',
  'CA Certification',
  'LLP Annual Filing',
  'IEC Registration',
  'MSME / Udyam Registration',
  'NRI Registration',
  'DSC / Digital Signature',
  'ISO Registration',
  'Trust Formation',
  'ROC Filing',
  'FSSAI Registration',
  'GST Return',
  'Director KYC',
  'Book Keeping Outsourcing',
  'Statutory Voluntary Audits',
  'Company Formation Registration',
  'FDI Compliance',
  'GST Registration',
  'Proprietorship Firm',
  'Partnership Firm',
  'One Person Company',
  'Limited Liability Partnership',
  'Private Limited Company',
  'Warehouse Registration',
  'Annual Filing',
];

export const advantages = [
  {
    title: 'Low Cost, No Hidden Charges',
    description: 'Transparent pricing with no surprises. Get quality service at affordable rates.',
    icon: 'wallet',
  },
  {
    title: 'Fast Growing Community',
    description: 'Join thousands of verified professionals delivering excellence every day.',
    icon: 'users',
  },
  {
    title: 'Talk to Real Professionals',
    description: 'Direct conversation with certified CAs, CS and tax experts — no bots.',
    icon: 'phone-call',
  },
  {
    title: 'Focused, Verified Audience',
    description: 'Every professional listed is verified for their credentials and expertise.',
    icon: 'target',
  },
];

export const marketplaceFeatures = [
  'Online Chartered Accountant',
  'Top Chartered Accountants in India',
  'List of Chartered Accountants',
  'Best Chartered Accountant in India',
  'Chartered Accountant Firm',
  'Best CA Firm in India',
  'Tax Consultant in India',
  'Online CA',
];

export const faqs = [
  {
    q: 'What questions should I ask before hiring a Chartered Accountant for my business?',
    a: 'Before hiring a Chartered Accountant, be clear about why you want to hire one. Ask questions like: How will a CA help in running my business? Will their expertise add value to my operations? What is the CA\'s area of specialization? Do they have industry experience relevant to your business?',
  },
  {
    q: 'How can online CA services provided by Register Point help in company registration?',
    a: 'Register Point provides both pre and post company registration services. Pre-registration includes registered office application, digital signature certificate, company name approval, capital subscription, and MOA/AOA preparation. Post-registration services include GST Registration, branch expansion, income tax return, annual return filing, and compliance related services.',
  },
  {
    q: 'How can I choose a reputed Chartered Accountant through Register Point?',
    a: 'Finding a reputed CA is easy with Register Point. Simply login to our home page, select the service you want to avail, browse the list of verified chartered accountants displayed, and choose the expert based on their specialization and ratings.',
  },
  {
    q: 'Which is the best income tax consultancy service provider in India?',
    a: 'Register Point is one of the best income tax consultancy platforms in India due to our wide reach. Chartered accountants at the PAN India level are registered on our platform. You can book an appointment for income tax consultancy with a CA in your area with just a few clicks.',
  },
  {
    q: 'What are the online CA services provided by Register Point?',
    a: 'We offer a full range: Company Registration, Startup Consultancy, Bookkeeping & Accounting, Annual Financial Reporting, Company Secretarial, Income Tax Planning, Due Diligence, Financial Planning, Auditing, GST Registration and Returns, International Taxation, FDI Consultancy, FSSAI Registration, Trademark Registration, MSME Registration, ROC Filing, APEDA Registration, Import Export Code, and much more.',
  },
  {
    q: 'Where would you find the best Chartered accountants in India?',
    a: 'At Register Point, we have a full fleet of online registered chartered accountants across India. We provide a one stop solution to all the financial & compliance services for your business needs across India. You can find a CA anywhere in India and have the option to book an appointment or avail their service online.',
  },
  {
    q: 'Why should I hire a Chartered Accountant for my business?',
    a: 'Hiring a CA is important because they are compliance experts. To effectively run your business, one must follow all rules and regulations. A CA helps with business growth, GST return filing, year-end reporting, effective compliance, minimizing income tax, accounting & bookkeeping, and other compliance requirements.',
  },
  {
    q: 'How does an online CA services provider work?',
    a: 'An online CA services provider like Register Point is a digital platform where you find the perfect financial & compliance solutions for your business. It breaks geographical barriers and helps you take advantage of Chartered accountant services online — instantly, remotely and reliably.',
  },
  {
    q: 'What skills do Chartered Accountants possess?',
    a: 'Chartered accountants are financial & compliance experts. Key skills include: experience in the relevant field, business analytical abilities, perfect foresightedness, strong communication, strong analytical skills, and being good with numbers.',
  },
  {
    q: 'How to find an income tax consultant?',
    a: 'Finding an income tax consultant is easy with Register Point. Login to our home page, select the service you want to avail, browse the list of experts, and choose the professional according to their specialization and location.',
  },
];

export const cities = [
  { name: 'Delhi', img: 'https://images.unsplash.com/photo-1587474260584-136574528ed5?w=400&auto=format&fit=crop' },
  { name: 'Noida', img: 'https://images.unsplash.com/photo-1616469829941-c7200edec809?w=400&auto=format&fit=crop' },
  { name: 'Bangalore', img: 'https://images.unsplash.com/photo-1596176530529-78163a4f7af2?w=400&auto=format&fit=crop' },
  { name: 'Hyderabad', img: 'https://images.unsplash.com/photo-1563448927992-9e4a5eeb3dcd?w=400&auto=format&fit=crop' },
  { name: 'Kanpur', img: 'https://images.unsplash.com/photo-1524492514790-8c22ec4028cc?w=400&auto=format&fit=crop' },
  { name: 'Mumbai', img: 'https://images.unsplash.com/photo-1570168007204-dfb528c6958f?w=400&auto=format&fit=crop' },
  { name: 'Pune', img: 'https://images.unsplash.com/photo-1567613056540-c39cc9ca9902?w=400&auto=format&fit=crop' },
];

export const articles = [
  {
    title: 'Talk to a Chartered Accountant (CA)',
    excerpt: 'Get instant answers to your tax, GST, and compliance questions from verified CAs in India.',
  },
  {
    title: 'Get Online CA Consulting Services in India',
    excerpt: 'Everything you need to know about hiring an online CA for your business or personal taxation needs.',
  },
  {
    title: 'Popular Chartered Accountants Service Platforms in India',
    excerpt: 'A curated look at the leading online CA service marketplaces and what makes them stand out.',
  },
];

export const updates = [
  { label: 'RBI for P2P', link: '#' },
  { label: 'SAHAJ FORM', link: '#' },
  { label: 'Amendment in Section 192', link: '#' },
  { label: 'Due Date Extended', link: '#' },
  { label: 'FRESH START SCHEME', link: '#' },
];

export const servicesTable = [
  ['Company Registration', 'Start-up Consultancy', 'Bookkeeping & Accounting', 'Annual Financial Reporting'],
  ['Company Secretarial', 'Income Tax Planning', 'Due Diligence', 'Financial Planning'],
  ['Auditing', 'GST Registration', 'GST Return Filing', 'International Taxation'],
  ['FDI Consultancy', 'FSSAI Registration', 'Trademark Registration', 'MSME Registration'],
  ['ROC Filing', 'APEDA Registration', 'Income Tax Return', 'TDS Return'],
  ['Financial Reporting', 'Business Valuation', 'Import Export Code', 'Online CA Services'],
];
